export default "__VITE_ASSET__D0bHDJie__"